<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">{{ 'Add Category' | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="onClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-sm-12">
        <form novalidate [formGroup]="categoryForm">
          <div class="form-group">
            <label for="name" class="control-label">
              {{ 'Name' | translate }}
            </label>
            <input
              #categoryName
              type="text"
              class="form-control"
              tabindex="0"
              id="name"
              formControlName="name"
              [class.is-invalid]="
                sent && categoryForm.get('name').hasError('required')
              "
              placeholder="{{ 'Online sales' | translate }}"
            />

            <span
              class="invalid-feedback"
              *ngIf="sent && categoryForm.get('name').hasError('required')"
            >
              {{ 'global.validators.required.error' | translate }}</span
            >
          </div>

          <div class="form-group">
            <label for="alias" class="control-label">
              {{ 'Alias' | translate }}
            </label>
            <input
              type="text"
              class="form-control"
              tabindex="0"
              id="alias"
              formControlName="alias"
              [class.is-invalid]="
                sent && categoryForm.get('alias').hasError('required')
              "
              placeholder="{{ 'online-sales' | translate }}"
            />

            <span
              class="invalid-feedback"
              *ngIf="sent && categoryForm.get('alias').hasError('required')"
            >
              {{ 'global.validators.required.error' | translate }}</span
            >
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-outline-secondary" type="button" (click)="onClose()">
      {{ 'Cancel' | translate }}
    </button>
    <button class="btn btn-primary" type="button" (click)="onSave()">
      <span *ngIf="!category || !category.id">{{ 'global.save' | translate }}</span>
      <span *ngIf="category && category.id">{{ 'Update' | translate }}</span>
    </button>
  </div>
</div>
